import { Component } from '@angular/core';
import { ImportedFilesListComponent } from '@src/base-components/management/imported-files-list/imported-files-list.component';

@Component({
    selector: 'app-imported-files-list-bellross',
    templateUrl: './imported-files-list-bellross.component.html',
    styleUrls: ['../../../../base-components/management/imported-files-list/imported-files-list.component.scss']
})
export class ImportedFilesListBellRossComponent extends ImportedFilesListComponent {}
